/* ------------------------------------------------------------------------
  Copyright (c) 2016, VoiceVibes, Inc

  VoiceVibes, Inc - PROPRIETARY/CONFIDENTIAL
  All contents of this file are proprietary and confidential. No part of
  any of the contents of this file may be disclosed in any manner to
  a third party without the prior written consent of VoiceVibes, Inc.
  Unauthorized copying of this file, via any medium is strictly prohibited.
----------------------------------------------------------------------------- */

<template>
  <span>
    <div
      :class="(screenSize === 'small') ? 'record-btn-outer mobile-rec-button-small' : 'record-btn-outer mobile-rec-button-big'"
      @click="recordClicked"
    >
      <svg class="svgicon icon-record">
        <use xlink:href="/static/svg-symbols.svg#icon-record" />
      </svg>
      <span>Record</span>
    </div>
  </span>
</template>

<style lang="less" scoped>
  .mobile-rec-button-small {
    position: absolute;
    right: 65px;
    top: 19px;
  }

  .mobile-rec-button-big {
    position: relative;
    top: 14px;
    left: 5px;
  }

  .record-btn-outer {
    display: inline-block;
    cursor: pointer;

    .svgicon {
      display: inline-block;
      stroke-width: 0;
      stroke: currentColor;
      fill: currentColor;
    }
    .icon-record {
      width: 23px; height: 23px;
    }
    span {
      color: #333;
      position: relative;
      bottom: 6px;
    }
  }
</style>

<script>
export default {
  props: {
    screenSize: { default: 'small', type: String },
  },
  data() {
    return {};
  },
  methods: {
    recordClicked() {
      this.$router.push({ name: 'record' });
    }
  }
};
</script>
